import { render } from "./LiveWebhook.vue?vue&type=template&id=604bf658&scoped=true"
import script from "./LiveWebhook.vue?vue&type=script&lang=js"
export * from "./LiveWebhook.vue?vue&type=script&lang=js"

import "./LiveWebhook.vue?vue&type=style&index=0&id=604bf658&scoped=true&lang=css"

import exportComponent from "C:\\All Projects\\Digital Sinage Main\\Digital Sinage Admin\\media-device-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-604bf658"]])

export default __exports__